<template lang="pug"> 
  v-row(no-gutters justify="center")
    v-col(align="center").pt-10
      v-img(width='80', src='@/assets/anything/checked.svg')  
      h2.green--text.mt-5  {{ $t('success-withdraw') }} 
      h4.mt-5 {{ $t('desc.waiting-withdraw') }}
      v-btn.mt-5(
        depressed
        dark
        color='var(--bg-secondary-color)'
        @click='toHomepage()'
      ) {{ $t('button.back-homepage') }}

</template> 

<script> 
import { ROUTE_INDEX } from '@/const/route'
export default {

  methods : {
    toHomepage () {
      this.$ga.event('Button', 'BackToHomePage', 'DepositPage','' )
      this.$router.push({
        name : ROUTE_INDEX
      }).catch(()=>{});  
    }
  }
}
</script> 